import React, {useState} from "react";
import PropTypes from 'prop-types'
import Rows from "./Rows";
import Columns from "./Columns";
import Values from "./Values";
import {
    Button,
    Card,
    Divider,
    Icon,
    IconButton,
    List,
    ListItem,
    ListItemText,
    makeStyles,
    Popover,
    Typography
} from "@material-ui/core";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../../../../JsonScreen/Utils/lib";
import FormField from "../../../../../../../Utils/Form/Fields/FormField";
import {set} from "object-path-immutable";

const PivotWrapper = (props) => {
    const {
        rowsColumns, pivotColumns, sourceColumns, data,
        valuesColumns, setValuesProps, setPivotColumnsProps, onChangePivotGrandTotal
    } = props;
    return (
        <>
            <legend style={{fontWeight: 'bold', paddingLeft: 5}}>
                Pivot Table
            </legend>
            <div style={{display: 'flex'}}>
                <div style={{width: '32.6%', margin: 2}}>
                    <Columns
                        pivotColumns={pivotColumns}
                        sourceColumns={sourceColumns}
                        setPivotColumnsProps={setPivotColumnsProps}
                    />
                </div>
                <div style={{width: '32.6%', margin: 2}}>
                    <Rows rowsColumns={rowsColumns}/>
                </div>
                <div style={{width: '32.6%', margin: 2}}>
                    <Values
                        valuesColumns={valuesColumns}
                        sourceColumns={sourceColumns}
                        setValuesProps={setValuesProps}
                    />
                </div>
            </div>
            <GrandTotalSettings
                pivot={data.pivot}
                onChangePivotGrandTotal={onChangePivotGrandTotal}
            />
        </>
    )
};

export default PivotWrapper

PivotWrapper.propTypes = {
    rowsColumns: PropTypes.array,
    pivotColumns: PropTypes.array,
    sourceColumns: PropTypes.array,
    valuesColumns: PropTypes.array,
    setPivotColumnsProps: PropTypes.func,
    setValuesProps: PropTypes.func
};

const useStyles = makeStyles(() => ({
    fieldset: {
        padding: 2,
        border: `1px solid #e5e5e5`,
        boxShadow: 'none'
    },
    cardContentWrapper: {
        overflowX: "hidden"
    },
    list: {
        paddingTop: 7,
    },
    listItemDense: {
        paddingTop: 0,
        paddingBottom: 0
    },
    editIcon: {
        padding: 0
    },
}))
const GrandTotalSettings = ({pivot = {}, onChangePivotGrandTotal}) => {
    const classes = useStyles();
    const [columnInEdit, setColumnInEdit] = useState({value: {}, path: ""});
    const [anchorEl, setAnchorEl] = useState(null)
    const {grandTotal = {}} = pivot;
    const onChangeProps = (event, path, isCheckBox) => {
        const newValues = set(columnInEdit.value, path, isCheckBox === true ? event.target.checked : event.target.value);
        setColumnInEdit((prev) => {
            return {
                path: prev.path, value: newValues
            }
        })
    };
    return (
        <div style={{padding: '5px 2px 5px 2px'}}>
            <Card className={classes.fieldset}>
                <legend style={{fontWeight: 'bold'}}>
                    Grand Total Settings
                </legend>
                <Divider/>
                <div className={classes.cardContentWrapper}>
                    <List dense={true}
                          className={classes.list}
                    >
                        <ListItem
                            classes={{dense: classes.listItemDense}}
                        >
                            <ListItemText
                                primary={"Row"}
                            />
                            <IconButton
                                size={"small"}
                                onClick={(e) => {
                                    setColumnInEdit({
                                        path: 'row',
                                        value: grandTotal.row
                                    })
                                    setAnchorEl(e.currentTarget)
                                }}
                                classes={{root: classes.editIcon}}>
                                <Icon fontSize={"small"}>
                                    more_vert
                                </Icon>
                            </IconButton>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            classes={{dense: classes.listItemDense}}
                        >
                            <ListItemText
                                primary={"Column"}
                            />
                            <IconButton
                                size={"small"}
                                onClick={(e) => {
                                    setColumnInEdit({
                                        path: 'column',
                                        value: grandTotal.column
                                    })
                                    setAnchorEl(e.currentTarget)
                                }}
                                classes={{root: classes.editIcon}}>
                                <Icon fontSize={"small"}>
                                    more_vert
                                </Icon>
                            </IconButton>
                        </ListItem>
                    </List>
                </div>
                <FormEditGrandTotal
                    anchorEl={anchorEl}
                    columnInEdit={columnInEdit.value}
                    onClose={() => {
                        setAnchorEl(null)
                        setColumnInEdit({value: {}, path: ""})
                    }}
                    setValues={(values) => {
                        onChangePivotGrandTotal(columnInEdit.path, values)
                    }}
                    onChangeProps={onChangeProps}
                />
            </Card>
        </div>
    )
}
const useFormEditStyles = makeStyles(({
    table: {
        width: '100%',
        marginTop: '5px',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    formActionsWrapper: {
        margin: '5px 5px 5px 0',
        textAlign: 'right',
    },
}))
const FormEditGrandTotal = (props) => {
    const columnSchema = {
        label: {
            type: "string",
            name: "label",
            label: "Label",
            path: "label",
            multiLanguage: true
        },
        hidden: {
            type: "switch",
            name: "hidden",
            path: "hidden",
            disabled: false
        },
    }
    const {anchorEl, columnInEdit} = props;
    const {setValues, onClose, onChangeProps} = props;
    const classes = useFormEditStyles();
    return (
        <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            PaperProps={{
                style: {maxWidth: 610}
            }}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <table className={classes.table}>
                <tbody>
                <tr>
                    <td className={classes.tableCellLabel}>{columnSchema.label.label}</td>
                    <td className={classes.tableCell}>
                        <FormField
                            field={columnSchema.label}
                            values={columnInEdit || {}}
                            onChange={onChangeProps}
                            path={columnSchema.label.path}
                        />
                    </td>
                </tr>
                <tr>
                    <td className={classes.tableCellLabel}>Hidden</td>
                    <td className={classes.tableCell}>
                        <FormField
                            field={columnSchema.hidden}
                            values={columnInEdit || {}}
                            onChange={onChangeProps}
                            path={columnSchema.hidden.path}
                        />
                    </td>
                </tr>
                </tbody>
            </table>

            <div className={classes.formActionsWrapper}>
                <Button size={"small"} variant="contained" color="primary"
                        onClick={() => {
                            setValues(columnInEdit);
                            onClose();
                        }}>
                    Apply
                </Button>
                <Button size={"small"} variant="contained" color="default" onClick={onClose}
                        style={{margin: "0 0 0 10px"}}>
                    Cancel
                </Button>
            </div>
        </Popover>
    )
};